import type { AppNavItem, AppNavigation } from '@/lib/app-navigation';
import { OPERATOR_ROLES } from '@/lib/app-navigation';
import { financeHref } from './book';
import { FINANCE_NAV_GROUP_ORDER, type FinanceAccess, visibleFinanceSurfaces } from './registry';

/** Nav rows come from the registry: one declaration per surface owns label, group, icon and RBAC. */
export function financeNavigation(access: FinanceAccess): AppNavigation {
  const grouped = new Map<string, AppNavItem[]>();
  for (const surface of visibleFinanceSurfaces(access)) {
    if (!surface.nav) continue;
    const item: AppNavItem = {
      id: surface.id,
      name: surface.nav.name,
      to: financeHref(surface.path, access.book),
      icon: surface.nav.icon,
      visibility: surface.nav.visibility === 'operator' ? OPERATOR_ROLES : undefined,
    };
    const label = surface.nav.group === 'top' ? '' : surface.nav.group;
    grouped.set(label, [...(grouped.get(label) ?? []), item]);
  }
  return {
    appName: 'Finances',
    groups: FINANCE_NAV_GROUP_ORDER.map((group) => (group === 'top' ? '' : group))
      .filter((label) => grouped.has(label))
      .map((label) => ({ label: label || undefined, items: grouped.get(label) ?? [] })),
  };
}
